import lottie from "lottie-web";

let animationPath;
let resizeTimeout;
let loadedAnimation = null;

const isFullMobile = () => window.innerWidth <= 840;

const getAnimationPath = (elementId) => {
  const animationContainer = document.getElementById(elementId);

  return animationContainer
    ? isFullMobile()
      ? animationContainer.getAttribute('data-mobile-src')
      : animationContainer.getAttribute('data-src')
    : null;
};

const heroAnimation = (elementId = 'hero-animation') => {
  const newAnimationPath = getAnimationPath(elementId);

  if (!newAnimationPath) return;

  animationPath = newAnimationPath;

  const homeTop = document.querySelector('.home-top');
  const container = document.querySelector('.home-top-container');
  let currentClipSize = 620;

  function updateClipPath(size) {
    if(!isFullMobile()) {
      size = Math.max(30, size);
      container.style.clipPath = `circle(${size}px at center)`;
      setTimeout(() => homeTop.classList.add('home-top-loaded'), 2000);
    }
  }

  const animationContainer = document.getElementById(elementId);
  if (loadedAnimation) {
    loadedAnimation.destroy();
  }

  loadedAnimation = lottie.loadAnimation({
    container: animationContainer,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: animationPath,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet'
    }
  });

  loadedAnimation.addEventListener('DOMLoaded', () => {
    updateClipPath(currentClipSize);
  });
};

const heroAnimationResizeInit = () => {
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      heroAnimation();
    }, 250);
  });
}

export { heroAnimation, heroAnimationResizeInit, loadedAnimation};
